import { NOTIFICATION_TYPES } from '../constants';

export const notificationMixin = {
  data() {
    return {
      notificationMessage: null,
      notificationType: 'info',
      notificationDuration: 3000
    }
  },
  methods: {
    showNotification(message, type = 'info', duration = 3000) {
      this.notificationMessage = message;
      this.notificationType = type;
      this.notificationDuration = duration;

      setTimeout(() => {
        this.notificationMessage = null;
      }, duration);
    }
  }
} 